export default __webpack_public_path__ + "static/media/arequipa-monastery_alley.764ddeaf.jpg";